@for (section of sections; track section) {
  <div class="row table-row no-gutters feedback-section"
    [class.selected]="section===selected">
    <div class="col-12 clickable section-header" style="display:flex">
      <span (click)="select(section)" style="flex-grow: 1">{{section.title}} </span>
    </div>
    <app-collapsible class="col-12 root-collapsible" [trigger]="section===selected">
      <app-collapsible [trigger]="section.helpVisible" class="help-block">
      </app-collapsible>
      <div style="padding-bottom: 10px;">
        @if (feedback[section.feedbackType]) {
          <div [innerHTML]="feedback[section.feedbackType]">
          </div>
        }
      </div>
      @if (feedback.performanceIndicator) {
        <div
          class="performance-indicator mt-3 mb-3 {{PerformanceIndicator[review.feedbackEdit.performanceIndicator]}}">
          {{PerformanceIndicator[review.feedbackEdit.performanceIndicator]}}
        </div>
      }
    </app-collapsible>
  </div>
}